import { useCallback } from 'react';

import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation } from '@tanstack/react-query';
import { Link, createFileRoute } from '@tanstack/react-router';
import { useForm } from 'react-hook-form';
import z from 'zod';

import { Button } from '@components/button';
import { Form } from '@components/form';
import { InputControlled } from '@components/input/controlled';
import { Card } from '@components/ui/card';
import { validationErrors } from '@errors/validation.error';

export const Route = createFileRoute('/_auth-layout/(auth)/forgot-password')({
  component: ForgotPassword,
});

const formSchema = z.object({
  email: z.email(validationErrors.email).min(1, {
    message: validationErrors.required,
  }),
});

function ForgotPassword() {
  // const navigate = useNavigate();
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    mode: 'onBlur',
    defaultValues: {
      email: '',
    },
  });

  const { isPending } = useMutation<
    void,
    unknown
    // ISendMailForgotPasswordSessionInputData
  >({
    // mutationFn: SessionService.sendMailForgotPassword,
    // onError: () => {
    //   toast.error('Atenção', {
    //     description: 'Não foi possível enviar o e-mail. Tente novamente',
    //   });
    // },
    // onSuccess: () => {
    //   navigate(pages.auth.signIn, { replace: true });
    //   toast.error('E-mail enviado com sucesso!');
    // },
  });

  const handleSubmit = useCallback((values: z.infer<typeof formSchema>) => {
    console.log('values', values);
    // await mutateAsync({
    //   email: values.email,
    // });
  }, []);

  return (
    <Form.Provider {...form}>
      <form onSubmit={form.handleSubmit(handleSubmit)}>
        <Card.Content className="mt-8 mb-8 p-0">
          <div className="space-y-4">
            <InputControlled
              autoCapitalize="off"
              autoComplete="off"
              design="auth"
              name="email"
              placeholder="E-mail"
              size="xl"
              type="email"
            />
            <Button
              className="mt-4 w-full shadow-none"
              disabled={isPending}
              isLoading={isPending}
              size="xl"
              type="submit">
              RECUPERAR SENHA
            </Button>
          </div>
        </Card.Content>
        <Card.Footer className="grid">
          <a
            className="text-primary mx-auto mb-6 block max-w-3/4 text-center text-sm font-light underline"
            href="https://api.whatsapp.com/send?phone=5517996261009"
            target="_blank">
            Precisa de ajuda? Clique aqui e entre em contato com o suporte
          </a>
          <Link
            className="text-primary mx-auto block w-fit text-center text-sm font-light underline"
            preload={false}
            to="/sign-in">
            Voltar
          </Link>
        </Card.Footer>
      </form>
    </Form.Provider>
  );
}
